// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"00ad1cc4","86":"51e9fd9b","119":"6552d159","164":"79b64ba2","453":"de235527","457":"dee4a87f","714":"1fda23de","779":"41b5c14c","941":"b850ad34"}[chunkId] + ".chunk.js";
};